export * from "./questionario.component";
export * from "./questionario.module";
